<template>
    <div>
        <div v-for="(singleList, k2) of content" :key="k2">
            <input :disabled="disabled" @input="handleInput" type="text" class="input-field" v-model="content[k2]">
        </div>
        <div v-if="!disabled" class="list-type-btn">
            <span class="btn-style add-btn" @click="add_singleList_item()"><span>+</span></span>
            <span class="btn-style remove-btn" v-if="content && content.length > 0" @click="remove_singleList_item(/*k2*/)"><span>--</span></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "listType",
    props: ['value','disabled'],
    data () {
        return {
            content: this.value
        }
    },
    methods: {
        remove_singleList_item(/*k*/) {
            this.content.splice(this.content.length - 1, 1)
            // this.content.splice(k, 1)
            this.handleInput()
        },
        add_singleList_item(){
            if(this.content){
                this.content.push("")
            }
            else{
                this.content = [""]
            }
            this.handleInput()
        },

        handleInput () {
            this.$emit('input', this.content)
            this.$emit('change', this.content)
        }
    },
    mounted(){
    }
}
</script>

<style lang="scss">
    .title {
        font-size: 14px;
        color: #191A23;
        font-weight: 300;
        margin: 4px;
    }
    .list-type-btn {
        display: flex;
        margin-top: 8px;
        .btn-style {
            display: flex;
            margin-right: 16px;
            background-color: #1B608C;
            color: #fff;
            border: none;
            width: 50px;
            border-radius: 28px;
            > span {
                margin-left: auto;
                margin-right: auto;
                font-size: 20px;
                font-weight: 400;
            }
            &:hover {
                cursor: pointer;
            }
        }
        .add-btn {
            margin-right: 16px;
        }
        .remove-btn {
            margin-left: 8px;
            > span {
                letter-spacing: -1px;
            }
        }
    }
</style>